export default __webpack_public_path__ + "static/media/postgre.1dc509ee.jpg";